import { useQuery } from '@tanstack/react-query';
import { getSplitDetails } from '@/api/getSplitDetails';
import { queryKeys } from '@/constants/queryKeys';

interface UseSplitDetailsOptions {
  orderNumber: string;
  enablePolling?: boolean;
  pollingInterval?: number;
}

export const useSplitDetails = ({
  orderNumber,
  enablePolling = true,
  pollingInterval = 30, // seconds
}: UseSplitDetailsOptions) => {
  return useQuery({
    queryKey: queryKeys.splitDetails({ orderNumber }),
    queryFn: ({ signal }) => getSplitDetails({ orderNumber, signal }),
    enabled: !!orderNumber,
    // Enable polling to check for split updates
    refetchInterval: enablePolling ? pollingInterval * 1000 : false,
    // Refetch when user returns to the tab
    refetchOnWindowFocus: true,
    // Reduce stale time for split details specifically
    staleTime: 2 * 60 * 1000, // 2 minutes instead of 15
  });
};
